import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchInspectors(serviceProviderId) {
    return RequesterV1.get(
      `service_provider/tech_visits/producer_inspectors/${serviceProviderId}/list_inspectors`
    );
  },

  fetchProducers(serviceProviderId, inspectorId, filters = {}) {
    return RequesterV1.get(
      `service_provider/tech_visits/producer_inspectors/${serviceProviderId}/list_producers/${inspectorId}`,
      { params: filters }
    );
  },
};
